<style lang="less" scoped>
@import "medias.less";
</style>
<template>
  <div class="media-list-box">
    <!-- <router-link to="/">
      <img src="../../assets/images/secondbanner.jpg" alt="">
    </router-link>
    <h1><span>媒体合作名录</span></h1> -->
    <div class="content" v-if="!isLoading">
      <div v-for="arr in exhibitions" :key="arr.AttendType" :class="arr.isOnlyOne === true ? 'box onebox' : 'box'">
        <h3>{{arr.AttendType}}</h3>
        <div class="item" v-for="item in arr.allData" :key="item.id">
          <div class="itembox">
            <div class="exhibitor-image"><img :src="item.LogoUrl" alt=""/></div>
            <p class="exhibitor-name">{{showName(item.Abbreviation, item.NativeName)}}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="loading">
      <img src="../../assets/images/loading.gif" alt="">
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      exhibitions: [],
      isLoading: true,
      allExhibition: []
    }
  },
  created () {
    this.getAllExhibitions()
  },
  methods: {
    getAllExhibitions: function () {
      let self = this
      self.$http.get('http://49.235.87.222:21000/api/v1/medias').then(function (res) {
        console.log(JSON.parse(res.data.data))
        if (res.data.code === 200) {
          self.allExhibition = JSON.parse(res.data.data)
          self.isLoading = false
          self.dealWithData(self.allExhibition)
        } else {
          console.log('Server error')
        }
      }).catch(function (err) {
        console.log(err)
      })
    },
    showName: function (abbreviation, nativeName) {
      if (abbreviation) {
        return abbreviation
      } else if (nativeName) {
        return nativeName
      } else {
        return ' '
      }
    },
    dealWithData: function (data) {
      let c = []
      let d = {}
      data.forEach(element => {
        if (!d[element.AttendType]) {
          c.push({
            AttendType: element.AttendType,
            allData: [element]
          })
          d[element.AttendType] = element
        } else {
          c.forEach(ele => {
            if (ele.AttendType === element.AttendType) {
              ele.allData.push(element)
            }
          })
        }
      })
      c.forEach(ele => {
        if (ele.allData.length === 1) {
          ele.isOnlyOne = true
        } else {
          ele.isOnlyOne = false
        }
      })
      this.exhibitions = c
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/medias/medias.vue